import interpolateComponents from '@automattic/interpolate-components';

import { CheckboxField } from 'components/Form/CheckboxField';
import { InfoBox } from 'components/InfoBox/InfoBox';
import { StyledNativeLinkWithRef } from 'components/Link/StyledNativeLinkWithRef';
import { BodySmall } from 'components/Text/BodySmall';

export function ListingViewApplicationFormConsentField({
  isEU,
  disabled,
}: {
  isEU: boolean;
  disabled?: boolean;
}) {
  return isEU ? (
    <CheckboxField
      name="consentAts"
      disabled={disabled}
      label={
        <BodySmall lineHeight={1.375} pt="calc(24px - 1em)">
          {interpolateComponents({
            mixedString: getText(
              'By using the Idealist Application system, I consent to ' +
                'sharing my resume and other personal data with potential ' +
                'employers in accordance with Idealist’s ' +
                '{{linkPrivacyPolicy}}Privacy Policy{{/linkPrivacyPolicy}} ' +
                'and {{linkTermsOfService}}Terms of Service{{/linkTermsOfService}}. ' +
                'If you request us to share your Application Information ' +
                'with an Organization outside Europe, you explicitly ' +
                'consent to the transfer of your Application ' +
                'Information outside Europe.',
            ),
            components: {
              linkPrivacyPolicy: (
                <StyledNativeLinkWithRef
                  target="_blank"
                  href={getText('/en/privacy-policy')}
                />
              ),
              linkTermsOfService: (
                <StyledNativeLinkWithRef
                  target="_blank"
                  href={getText('/en/terms-of-service')}
                />
              ),
            },
          })}
        </BodySmall>
      }
    />
  ) : (
    <InfoBox $type="info" data-qa-id="consent-ats-text">
      <BodySmall lineHeight={1.375}>
        {interpolateComponents({
          mixedString: getText(
            'I acknowledge that use of the Idealist Applicant Tracking System is ' +
              "subject to Idealist's " +
              '{{linkPrivacyPolicy}}Privacy Policy{{/linkPrivacyPolicy}} ' +
              'and {{linkTermsOfService}}Terms of Service{{/linkTermsOfService}}.',
          ),
          components: {
            linkPrivacyPolicy: (
              <StyledNativeLinkWithRef
                target="_blank"
                href={getText('/en/privacy-policy')}
              />
            ),
            linkTermsOfService: (
              <StyledNativeLinkWithRef
                target="_blank"
                href={getText('/en/terms-of-service')}
              />
            ),
          },
        })}
      </BodySmall>
    </InfoBox>
  );
}
